export default __webpack_public_path__ + "static/media/poster3.197e3ba6.png";